'use strict';

var React = require('react');

var SvgPasskeyMinor = function SvgPasskeyMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.695 12.133c-.298.213-.392.659-.133.918a.776.776 0 0 1 0 1.098l-.118.117a.943.943 0 0 0 0 1.334.943.943 0 0 1 0 1.333l-.757.758a.5.5 0 0 1-.707 0l-1.132-1.132a1 1 0 0 1-.292-.707v-3.44a3.111 3.111 0 1 1 3.139-.279Zm-1.806-3.867a.889.889 0 1 1 0 1.778.889.889 0 0 1 0-1.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.702 11.093c-.699-.163-1.52-.259-2.48-.259-5.055 0-6.222 2.642-6.222 3.95 0 1.31 1.045 2.371 2.333 2.371h7.778c.037 0 .074 0 .111-.003v-3.997a4.456 4.456 0 0 1-1.52-2.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }));
};

exports.SvgPasskeyMinor = SvgPasskeyMinor;
